<ion-header [translucent]="true" class="ion-no-border">
  <ion-row>
    <ion-col>
     
        <ion-icon style="float: right;" name="close" (click)="closeUserLoginModal()">
        </ion-icon> 
        <ion-text  class="title">Login</ion-text>      
      <!-- @if (title=='Invitations') {
      <ion-text style="float: right;" (click)="addInvitation()">Add New Invitation</ion-text>
      <ion-icon style="float: right;" name="add-circle-outline"></ion-icon>
      } -->
    </ion-col>
  </ion-row>
</ion-header>
  <ion-content>
    <div >
      <ion-card style="padding: 10px;">
        <form [formGroup]="mobileForm" >
          <ion-row>
            <ion-col size="3.5"><mat-form-field appearance="outline" style="width: 100%; ">
                <input matInput class="form-control" [(ngModel)]="mobileform.code" formControlName="code"
                  style="background: transparent;" readonly>
              </mat-form-field></ion-col>
            <ion-col size="8.5"><mat-form-field appearance="outline" style="width: 100%; padding: 0px 0px;">
                <input matInput [(ngModel)]="mobileform.mobile" formControlName="mobile" class="form-control"
                  style="background: transparent;" placeholder="Enter Mobile Number" maxlength="10">
                <mat-error>Enter valid mobile no.</mat-error>
              </mat-form-field></ion-col>
  
  
          </ion-row>
          <ion-button style="height: 31px;width: 110px;" class="submit-button" [disabled]="mobileForm.invalid"
            (click)="sendMobileOTP()">Send OTP</ion-button>
        </form>
      </ion-card>
  
    </div>
  </ion-content>
  <!-- </ion-grid> -->  